<template>
  <div class="dialogs">
    <dialog-box
      class="dialog-item"
      v-for="(message, i) in messages"
      :key="`${message.id}-${message.isOpened ? 'read' : 'unread'}`"
      :message="message"
      :data-index="i"
    />
  </div>
</template>

<script>
import DialogBox from '@/components/game/DialogBox';

export default {
  name: 'Dialogs',
  components: {
    'dialog-box': DialogBox,
  },
  methods: {
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      const index = parseInt(el.dataset.index) - 1;
      const delay = index * 100;

      setTimeout(function() {
        el.style.opacity = 1;
      }, delay);
    },
    leave(el, done) {
      el.style.opacity = 0;
    },
  },
  computed: {
    messages() {
      return this.$store.state.game.notifications;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/game/Dialogs.vue